import BaseComponent from '../base-component/base-component'
import { delay } from '../../utils/utils'
import ClipboardButtonTooltip from './clipboard-button-tooltip'

class ClipboardButton extends BaseComponent {
  connectedCallback(): void {
    this.addEventListener('click', this.handleButtonClick)
  }

  disconnectedCallback(): void {
    this.removeEventListener('click', this.handleButtonClick)
  }

  handleButtonClick = (): void => {
    this.copy()
  }

  copy = (): void => {
    const value = this.dataset.value

    if (value && navigator.clipboard) {
      navigator.clipboard
        .writeText(value)
        .then(() => {
          this.showTooltip()
        })
        .catch(e => {
          if (window.Shopify.designMode) {
            // The Clipboard API blocked in Shopify editor
            this.showTooltip()
          }
          throw e
        })
    }
  }

  showTooltip(): void {
    const tooltipId = this.dataset.tooltipId

    if (!tooltipId) {
      return
    }

    const tooltip = document.getElementById(tooltipId) as ClipboardButtonTooltip

    if (tooltip) {
      tooltip.show()

      delay(1000).then(() => {
        tooltip.hide()
      })
    }
  }
}

export default ClipboardButton
